import Layout from './Layout';
import Message from './Message';
import React from 'react';
import Button from '@rezdy/components/Button';
import TextStyle from '@rezdy/components/TextStyle';
import { REZDY_APP } from '../constants/auth';
import redirect from '../actions/redirect';
import { ErrorMessage } from './ErrorMessage';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IErrorView extends WithTranslation {
    children: any;
}

interface IErrorState {
    hasError: boolean;
    error: any;
}

class ErrorBoundary extends React.Component<IErrorView, IErrorState> {
    constructor(props: IErrorView) {
        super(props);
        this.state = { error: null, hasError: false };
    }

    onSecondaryClick = () => {
        redirect({
            redirect_uri: `${REZDY_APP}/logout`,
        });
    };

    renderSecondaryAction = () => {
        const { i18n } = this.props;
        return (
            <Button action="secondary" onClick={this.onSecondaryClick} reversed>
                {i18n.t('secondaryAction')}
            </Button>
        );
    };

    componentDidCatch(error: any, info: any) {
        this.setState({ error, hasError: true });
    }

    render() {
        if (this.state.hasError) {
            const { i18n } = this.props;
            const { error } = this.state;
            const message = <ErrorMessage isDirty={true} i18nKey={error ?? 'UNKNOWN'}></ErrorMessage>;
            const context = 'retry';

            return (
                <Layout secondaryAction={this.renderSecondaryAction()}>
                    {message}
                    <TextStyle align="center">Or</TextStyle>
                    <Button action="secondary" onClick={this.onSecondaryClick}>
                        {i18n.t('secondaryAction', { context })}
                    </Button>
                </Layout>
            );
        }
        return this.props.children;
    }
}

export default withTranslation()(ErrorBoundary);
